import { useGetGroupsTableRouter } from 'widgets/groups/trainingGroupsTable/GroupsTable/fn/getGroupsTableRouter'

export const TrainingGroupsTableController = {
	router: useGetGroupsTableRouter,
}
